import { Grid, TextField } from '@mui/material'
import yaml from 'js-yaml'
import Drawer from 'components/drawer/detail'
import Loading from 'components/loading/loading'
import { useGetInboxDetailQuery } from 'store/inbox'
import type { NotificationProps } from 'modules/types'
import GLOBAL from 'modules/global'

type InboxDetailProps = {
  id: number | string | null
  open: boolean
  onClose: () => void
}

const fields: Array<{ label: string; key: keyof ReturnType<typeof mapData> }> = [
  { label: 'Title', key: 'title' },
  { label: 'Body', key: 'body' },
  { label: 'Data', key: 'data' },
  { label: 'Created At', key: 'createdAt' },
  { label: 'Created By', key: 'createdBy' }
]

function mapData(d?: NotificationProps) {
  const data = GLOBAL.deepParseJSON(d?.data || '{}')
  const humanizedData = GLOBAL.humanizeKeys(data)
  const yamlString = yaml.dump(humanizedData) as string

  return {
    title: d?.title || '-',
    body: d?.body || '-',
    data: yamlString || '-',
    createdAt: d?.createdAt ? GLOBAL.formatDateWithTimeSecond(d.createdAt) : '-',
    createdBy: d?.createdBy || '-'
  }
}

const InboxDetail = ({ id, open, onClose }: InboxDetailProps) => {
  const {
    data = [],
    isLoading,
    isFetching
  } = useGetInboxDetailQuery(id as number, { skip: !id || !open })
  const [notif] = data
  const mapped = mapData(notif)

  return (
    <Drawer title='Inbox Detail' open={open} onClose={onClose} maxWidth='sm'>
      {(isLoading || isFetching) && <Loading />}
      <Grid container spacing={2} sx={{ mt: 0.5, p: 3 }}>
        {fields.map((f) => (
          <Grid item xs={12} key={f.key as string}>
            <TextField
              label={f.label}
              multiline
              value={mapped[f.key] as string}
              fullWidth
              inputProps={{ readOnly: true }}
            />
          </Grid>
        ))}
      </Grid>
    </Drawer>
  )
}

export default InboxDetail
